import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { accounts, inProgress } = useMsal();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    // Wait for MSAL to finish checking authentication
    if (inProgress === "none") {
      const authStatus = accounts && accounts.length > 0;
      setIsAuthenticated(authStatus);
      setAuthLoading(false);
    }
  }, [accounts, inProgress]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, authLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
